import EventEmitter from './EventEmitter';
import ModalInterface from '../modules/ModalInterface';
import DomU, {$} from './DomU';
import WinU from './WinU';
import KeyCodes from '../constants/KeyCodes';
import Router from './Router';
import Browsers from '../constants/Browsers';

function hash2name(hash: string = '') {
  return hash.split('/m/')[1] || '';
}

export default new class ModalCtrl extends EventEmitter {
  private _modals: { [name: string]: ModalInterface } = {};
  private $html: DomU;
  private $body: DomU;
  private _currentModal: ModalInterface;
  private _currentName: string = '';
  private _opened: boolean = false;
  private _directModalMode: boolean;
  private _isTouchMoved: boolean;
  private _isSmall: boolean = false;
  private _smallDelay: any;

  get currentName(): string {
    return this._currentName;
  }

  get opened(): boolean {
    return this._opened;
  }

  register(name: string, instance: ModalInterface) {
    if (this._modals[name]) console.error(`[ModalCtrl] duplicate registerd: ${name}`);
    this._modals[name] = instance;
  }

  setup() {
    this.$html = $('html');
    this.$body = $(document.body);
    if (Browsers.desktop) {
      this.$body.on('click', this._bodyClickHdl.bind(this));
    } else {
      this.$body
        .on('touchstart', this._touchStarted.bind(this))
        .on('touchmove', this._touchMoved.bind(this))
        .on('touchend', this._touchEnded.bind(this));
    }
    Router.on(Router.e.change, this._urlChangeHdl.bind(this));
    WinU.on(WinU.e.keyUp, this._keyHdl.bind(this));
    this._urlChangeHdl();
    this._directModalMode = this._opened;
  }

  onToggleOpened(f:Function) {
    this.on('toggleOpened', f);
  }

  onSwitch(f:Function) {
    this.on('switch', f);
  }

  close() {
    this._close();
  }

  _switch(name: string) {
    if (this._currentName === name) return;
    this._currentName = name;

    this.$html.attr('data-current-modal', name);

    const oldModal = this._currentModal;
    this._currentModal = this._modals[name];

    const opened = !!this._currentModal;

    this._isSmall = !!(this._currentModal && this._currentModal.isSmall && this._currentModal.isSmall());
    clearTimeout(this._smallDelay);
    if(opened) {
      this.$html.toggleClass('is_modalSmall', this._isSmall);
    } else {
      this._smallDelay = setTimeout(()=> {
        this.$html.removeClass('is_modalSmall');
      }, 500);
    }

    if (this._opened !== opened) {
      this._opened = opened;
      this.emit('toggleOpened', opened);

      // WinU.switchModal(opened, opened ? 0 : 200);
      WinU.switchModal(opened, opened ? 0 : 0);

      if(opened) {
        this.$html.addClass('is_modalVisible');
        this.$html.delay(33, ()=> {
          this.$html.addClass('is_modalShow');
        });
      } else {
        this.$html.removeClass('is_modalShow');
        this.$html.delay(200, ()=> {
          this.$html.removeClass('is_modalVisible');
        });
      }
    }

    if (oldModal) oldModal.toggleOpen(false);
    if (this._currentModal) this._currentModal.toggleOpen(true);

    this.emit('switch', true);
  }

  _urlChangeHdl() {
    const name = hash2name(Router.state.hash);
    this._switch(name);
  }

  _close() {
    if (this._directModalMode) {
      //モーダルに直アクセスの場合はヒストリーがないのでback()でなくURL変更
      this._directModalMode = false;
      Router.restoreInitial({withHash: false, replace: false});
    } else {
      window.history.back();
    }
  }

  _bodyClickHdl(e: Event) {
    this._elClicked(e);
  }

  _touchStarted(e: TouchEvent) {
    this._isTouchMoved = false;
  }

  _touchMoved(e: TouchEvent) {
    this._isTouchMoved = true;
  }

  _touchEnded(e: TouchEvent) {
    if (!this._isTouchMoved) this._elClicked(e);
  }

  _elClicked(e: Event) {
    const $button = $(e.target);
    if (
      $button.hasClass('js_modal_close')
      || ($button.hasClass('js_modal_content') && this._isSmall)
      || ($button.hasClass('js_modal_toggle') && this._opened)
    ) {
      e.preventDefault();
      e.stopPropagation();
      this._close();
      return;
    }
    const href = $button.attr('href');
    if (!href) return;
    const name = hash2name(href);
    if (name && (this._currentName !== name)) {
      Router.change(`#/m/${name}`, {replace: false});
    }
  }

  _keyHdl(e: KeyboardEvent) {
    if (!this._opened) return;
    if (e.keyCode === KeyCodes.ESC) this._close();
  }

}();
